import React, { useEffect, useState } from 'react';
import { DragDropContext, DropResult } from '@hello-pangea/dnd';
import { Box, CircularProgress, Typography } from '@mui/material';

// A simpler wrapper using the @hello-pangea/dnd library which is React 18 compatible
const DragDropWrapper: React.FC<{
  onDragStart?: (start: any) => void;
  onDragEnd: (result: DropResult) => void;
  children: React.ReactNode;
}> = ({ onDragStart, onDragEnd, children }) => {
  const [loading, setLoading] = useState(true);

  // A short delay to ensure everything is ready
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);
  
  const handleDragStart = (start: any) => {
    document.body.style.cursor = 'grabbing';
    document.body.classList.add('dragging-active');
    
    // Call parent onDragStart if provided
    if (onDragStart) {
      onDragStart(start);
    }
  };
  
  const handleDragEnd = (result: DropResult) => {

    document.body.style.cursor = '';
    document.body.classList.remove('dragging-active');
    onDragEnd(result);
  };
  
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
        <CircularProgress size={20} sx={{ mr: 1 }} />
        <Typography variant="body2" color="text.secondary">
          Initializing drag and drop...
        </Typography>
      </Box>
    );
  }
  
  return (
    <DragDropContext 
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
    >
      {children}
    </DragDropContext>
  );
};

export default DragDropWrapper; 